// extracted by mini-css-extract-plugin
export default {"wrapper":"BriefInput_wrapper__zvjg7","input":"BriefInput_input__pL9OL","textarea":"BriefInput_textarea__j2Ssp","offset":"BriefInput_offset__v1zfh"};